import Grid from '@mui/material/Grid';
import Divider from '@mui/material/Divider';
import React from 'react';
import { useIntl } from 'react-intl';

export function DividerLine() {
  const { formatMessage } = useIntl();
  return (
    <Grid container direction="row" justifyContent="center" alignItems="center">
      <Grid item xs={5}>
        <Divider sx={{ borderColor: "#fff" }} />
      </Grid>
      <Grid item xs={2} style={{ color: '#fff', textAlign: 'center' }}>
        {formatMessage({ id: 'divider-line.text' })}
      </Grid>
      <Grid item xs={5}>
        <Divider sx={{ borderColor: "#fff" }} />
      </Grid>
    </Grid>
  );
}
